import type { useFormatDateReturnType } from '~/i18n/hooks/useFormatDate/types';
import type { useFormatNumberReturnType } from '~/i18n/hooks/useFormatNumber/types';

import { Fields } from '~/features/document-handler/types/fields';
import { pilot } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

import type { DocumentInformationResponse } from './getDocumentFields';

import { mapResponse } from './getDocumentFields';

type Request = {
  tag: Uuid;
  formatDate: useFormatDateReturnType;
  formatNumber: useFormatNumberReturnType;
};

export const getCLMeDocumentInformation = async ({
  tag,
  formatDate,
  formatNumber,
}: Request): Promise<Fields> => {
  const response: DocumentInformationResponse = await pilot.get(
    '/document/clme/document-information',
    { params: { tag } },
  );

  return mapResponse(response, formatDate, formatNumber);
};
